var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    pwSwiper: function () {
      return import(
        /* webpackChunkName: "uni_modules/uce-q-bank/components/pw-swiper/pw-swiper" */ "@/uni_modules/uce-q-bank/components/pw-swiper/pw-swiper.vue"
      )
    },
    mpHtml: function () {
      return import(
        /* webpackChunkName: "uni_modules/mp-html/components/mp-html/mp-html" */ "@/uni_modules/mp-html/components/mp-html/mp-html.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-modal/u-modal" */ "uview-ui/components/u-modal/u-modal.vue"
      )
    },
    uToast: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-toast/u-toast" */ "uview-ui/components/u-toast/u-toast.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 =
    !_vm.checkAnswer && _vm.collection
      ? _vm.questionList.length != 0 &&
        _vm.vk.pubfn.isNull(_vm.questionList[_vm.currentIndex].star)
      : null
  var m0 = _vm.$hasSSP("0e726f4c-4")
  var m1 = m0
    ? _vm.qType(_vm.$getSSP("0e726f4c-4", "default")["item"].type)
    : null
  var m2 = m0 ? _vm.$getSSP("0e726f4c-4", "default") : null
  var g1 = m0 ? _vm.questionList.length : null
  var m3 = m0 ? _vm.$getSSP("0e726f4c-4", "default") : null
  var m4 = m0
    ? _vm.$getSSP("0e726f4c-4", "default")["item"].type == 1 ||
      _vm.$getSSP("0e726f4c-4", "default")["item"].type == 3
    : null
  var l0 =
    m0 && m4
      ? _vm.__map(
          _vm.$getSSP("0e726f4c-4", "default")["item"].answerList,
          function (answer, a_index) {
            var $orig = _vm.__get_orig(answer)
            var m5 = _vm.$getSSP("0e726f4c-4", "default")
            var m6 = _vm.$getSSP("0e726f4c-4", "default")
            return {
              $orig: $orig,
              m5: m5,
              m6: m6,
            }
          }
        )
      : null
  var m7 = m0 ? _vm.$getSSP("0e726f4c-4", "default") : null
  var l1 =
    m0 && m7["item"].type == 2
      ? _vm.__map(
          _vm.$getSSP("0e726f4c-4", "default")["item"].answerList,
          function (answer, a_index) {
            var $orig = _vm.__get_orig(answer)
            var m8 = _vm.$getSSP("0e726f4c-4", "default")
            var m9 =
              _vm.answercard[_vm.$getSSP("0e726f4c-4", "default")["item"]._id]
                .a &&
              _vm.answercard[
                _vm.$getSSP("0e726f4c-4", "default")["item"]._id
              ].a.indexOf(a_index) != -1
            return {
              $orig: $orig,
              m8: m8,
              m9: m9,
            }
          }
        )
      : null
  var m10 =
    m0 && _vm.checkAnswer
      ? _vm.rightAnswer(_vm.$getSSP("0e726f4c-4", "default")["item"])
      : null
  var m11 = m0 && _vm.checkAnswer ? _vm.$getSSP("0e726f4c-4", "default") : null
  var g2 =
    _vm.cardHidden && !(_vm.checkAnswer == false)
      ? _vm.questionList.length != 0 &&
        _vm.vk.pubfn.isNull(_vm.questionList[_vm.currentIndex].star)
      : null
  var g3 = _vm.cardHidden
    ? _vm.questionList && _vm.currentIndex < _vm.questionList.length - 1
    : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.collection = !_vm.collection
    }
    _vm.e1 = function ($event, a_index, answer) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        a_index = _temp2.a_index,
        answer = _temp2.answer
      var _temp, _temp2
      return _vm.choose(
        a_index,
        answer.isRight,
        _vm.$getSSP("0e726f4c-4", "default")["item"],
        _vm.$getSSP("0e726f4c-4", "default")["item"].type
      )
    }
    _vm.e2 = function ($event, a_index, answer) {
      var _temp3 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp4 = _temp3.eventParams || _temp3["event-params"],
        a_index = _temp4.a_index,
        answer = _temp4.answer
      var _temp3, _temp4
      return _vm.choose(
        a_index,
        answer.isRight,
        _vm.$getSSP("0e726f4c-4", "default")["item"],
        _vm.$getSSP("0e726f4c-4", "default")["item"].type
      )
    }
    _vm.e3 = function ($event) {
      _vm.cardHidden = false
    }
    _vm.e4 = function ($event) {
      _vm.checkAnswer = true
    }
    _vm.e5 = function ($event, item) {
      var _temp5 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp6 = _temp5.eventParams || _temp5["event-params"],
        item = _temp6.item
      var _temp5, _temp6
      _vm.cardHidden = true
      _vm.currentIndex = item.no - 1
    }
    _vm.e6 = function ($event, item) {
      var _temp7 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp8 = _temp7.eventParams || _temp7["event-params"],
        item = _temp8.item
      var _temp7, _temp8
      _vm.cardHidden = true
      _vm.currentIndex = item.no - 1
    }
    _vm.e7 = function ($event, item) {
      var _temp9 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp10 = _temp9.eventParams || _temp9["event-params"],
        item = _temp10.item
      var _temp9, _temp10
      _vm.cardHidden = true
      _vm.currentIndex = item.no - 1
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        m0: m0,
        m1: m1,
        m2: m2,
        g1: g1,
        m3: m3,
        m4: m4,
        l0: l0,
        m7: m7,
        l1: l1,
        m10: m10,
        m11: m11,
        g2: g2,
        g3: g3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }